import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationService } from 'services/notification.service';
import { RelationService } from 'services/relation.service';
declare const JSON: { retrocycle: any };

@Injectable() export class AppHttpInterceptor implements HttpInterceptor {
	constructor(private readonly notificationService: NotificationService) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		if (!req.url.startsWith(environment.gatewayUrl)) return next.handle(req);

		req = req.clone({
			body: req.body instanceof FormData ? req.body : RelationService.removeRelationProperties([req.body])[0],
			withCredentials: true
		});
		return next.handle(req).pipe(
			map(event => {
				if (event instanceof HttpResponse) {
					const controller = event.headers.get('X-Api-Controller') as string;
					if (controller) event = event.clone({ body: RelationService.instantiateModelsForControllerMethod(controller, event.headers.get('X-Api-Method') as string, event.body) });
					else console.warn("Missing controller header from " + event.url + ". Ignoring model handling.");

					event = JSON.retrocycle(event);
				}
				return event;
			}),
			catchError((response: HttpErrorResponse) => {
				if (response.status === 503) {
					this.notificationService.status('status.service-unavailable', 'exclamation-triangle', response.error?.developerMessage?.message ?? response.error);
				}
				else if (response.status && response.error?.developerMessage) {
					const errorDetails = response.error.developerMessage;

					let errorDescription = errorDetails.message;
					if (errorDetails.innerException) errorDescription += `\n\nInner exception (see console):\n${errorDetails.innerException.message}`;

					this.notificationService.error('general.error', errorDescription, errorDetails.stackTrace, response.error.operationId);
				}
				if (response.error && response.status !== 404) console.error('Error communicating with backend:', response.error);
				return throwError(response);
			}))
	}
}
